import React, { useState } from 'react';
import { Button } from 'antd-mobile';
import { WebviewHttpHandler } from 'shared/webviewHttpHandler';
import { CryptoHandler } from '../shared/cryptoHandler';

const VerifyCodeButton = ({ onClick, loading }) => (
  <Button className={'send-verify-code'} onClick={onClick} loading={loading}>
    發送驗證碼
  </Button>
);

const VerifyCodeComponent = ({ apiData }) => {
  const httpHandler = new WebviewHttpHandler();
  const cryptoHandler = new CryptoHandler();
  const [loading, setLoading] = useState(0);

  const handleSendVerifyCode = () => {
    setLoading(true);

    const { identity, phone, category } = apiData;

    let identityRegex = /.*/;
    let errorFlag = false;
    switch (category) {
      case 1:
        identityRegex = /^[A-Z][0-9]{9}$/;
        if (!identityRegex.test(identity)) {
          errorFlag = true;
          window.antdNotify(
            '格式錯誤',
            '請先填入“身分證字號” (大寫英文+9碼數字)',
            'fail'
          );
        }
        break;

      case 2:
        identityRegex = /^\d{8}$/;
        if (!identityRegex.test(identity)) {
          errorFlag = true;
          window.antdNotify('格式錯誤', '請先填入“統一編號” (8碼數字)', 'fail');
        }
        break;

      case 3:
        identityRegex = /^\d{5}$/;
        if (!identityRegex.test(identity)) {
          errorFlag = true;
          window.antdNotify('格式錯誤', '請先填入“員工編號” (5碼數字)', 'fail');
        }
        break;

      default:
        break;
    }

    const phoneRegex = /[0-9]{10}$/;
    if (!phoneRegex.test(phone)) {
      errorFlag = true;
      window.antdNotify('格式錯誤', '請先填入"手機號碼" (10碼數字)', 'fail');
    }

    if (!errorFlag) {
      const encryptedIdentity = cryptoHandler.encrypt(apiData.identity);
      const encryptedPhone = cryptoHandler.encrypt(apiData.phone);
      httpHandler
        .post(`/account/OTP/send`, {
          ...apiData,
          identity: encryptedIdentity,
          phone: encryptedPhone,
        })
        .then((response) => {
          if (response.success) {
            window.antdNotify('成功', response.message, 'success');
          } else {
            console.log(response);
            window.antdNotify('失敗', response.message, 'fail');
          }
        })
        .catch((error) => {
          setLoading(false);
          console.log(error);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  };

  return (
    <VerifyCodeButton
      onClick={handleSendVerifyCode}
      loading={loading}></VerifyCodeButton>
  );
};

export default VerifyCodeComponent;
